import {connect} from "react-redux";
import {Box, Modal, Dialog as MuiDialog} from "@mui/material";
import React from "react";

type Props = {
    children: React.ReactNode
    onClose: () => any
}
function Dialog({children, onClose}: Props) {
    const handleModalClose = (event: MouseEvent) => {
        onClose();
        event.stopPropagation();
    }
    return (
        <Modal open={true} onClose={handleModalClose}>
            <Box display='flex' margin={4}>
                <MuiDialog open={true} onClose={handleModalClose}>
                    {children}
                </MuiDialog>
            </Box>
        </Modal>
    );

}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(Dialog);
